import { Node_Type } from "./../ricos-types/index.js";
const FILE_BUTTONS = {
  alignment: `${Node_Type.FILE}.alignment`,
  size: `${Node_Type.FILE}.size`
};
export {
  FILE_BUTTONS
};
//# sourceMappingURL=consts.js.map
